import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { CheckForErrorsMessageComponent } from '../../../../shared-components/guards/check-for-errors/check-for-errors-message/check-for-errors-message.component';
import { SharedService } from '../../../../shared-components/shared.service';
import { UserService } from '../../../../shared-components/user/user.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { SpedCardsService } from '../../../sped-home/sped-cards/sped-cards.service';
import { AccomodationBank } from '../../../sped-management/sped-management.model';
import { SpedManagementService } from '../../../sped-management/sped-management.service';
import { Sped360Service } from '../../../sped360.service';
import { ViewDocumentComponent } from '../../../student-document-home/sped-student-document-cards/sped-student-collection-common-card/view-document/view-document.component';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { IepFormsWithinDocuments, PlaMaintenance } from '../../formwithin-document-modal';
import { PickCourseOfStudyComponent } from '../../maintenance-modals/pick-course-of-study/pick-course-of-study.component';
import { PickGoalMaintenanceComponent } from '../../maintenance-modals/pick-goal-maintenance/pick-goal-maintenance.component';
import { PickIdentificationMaintenanceComponent } from '../../maintenance-modals/pick-identification-maintenance/pick-identification-maintenance.component';
import { PresentLevelMaintenanceComponent } from '../../maintenance-modals/present-level-maintenance/present-level-maintenance.component';
import { CheckInCheckOutComponent } from '../check-in-check-out/check-in-check-out.component';
import { IndeterminateProgressBarComponent } from '../indeterminate-progress-bar/indeterminate-progress-bar.component';



@AutoUnsubscribe()
@Component({
  selector: 'app-edit-html-form',
  templateUrl: './edit-html-form.component.html',
  styleUrls: ['./edit-html-form.component.css']
})
export class EditHtmlFormComponent implements OnInit, AfterViewInit, OnDestroy {
  warningDialog: MatDialogRef<CheckForErrorsMessageComponent>;
  @ViewChild('iframe') iframe: ElementRef;

  dialogTitle = '';
  formSrc: any;
  htmlElements = [];
  studentFormData: any;
  dataField = new IepFormsWithinDocuments();
  yearId: number;
  schoolId: number;
  ddData: IepFormsWithinDocuments[] = [];
  getSelectedPlaValues: PlaMaintenance[] = [];
  objectIndex: number;
  selectedForm: any;
  studentCollectionTemplateVersionId: number;
  isEdit: boolean;
  callForSaveSubscription: Subscription;
  selectedFormDataSubscription: Subscription;
  stateCode = '';
  userId: number;
  getsingleValue = new PlaMaintenance();
  getCosData: AccomodationBank[] = [];
  canEditForm = true;
  checkOutDocument: boolean;
  checkOutDocument504: boolean;
  onlySaveClick: boolean;
  previousSelectedForm: any;
  formStatus: string;
  iconAllowed: boolean;
  collectionCode: string;
  fileAsBlob: Blob;
  navigateToForm = false;
  callFromNgOnInit: boolean;
  changeStatus: string;
  disableNavigationButton = false;

  constructor(
    private matDialogRef: MatDialogRef<EditHtmlFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private spedCardService: SpedCardsService,
    private sanitizer: DomSanitizer,
    private yearService: YearService,
    private formWithinDocumentService: FormWithinDocumentsService,
    private dialog: MatDialog,
    private loginService: LoginService,
    private userService: UserService,
    private spedManagementService: SpedManagementService,
    private sped360Service: Sped360Service,
    private sharedService: SharedService,
    private router: Router
  ) {

    (<any>window).navigateToMaint = this.navigateToMaint.bind(this);
    (<any>window).navigateToEvalMaint = this.navigateToEvalMaint.bind(this);
    (<any>window).navigateToGoalORMaint = this.navigateToGoalORMaint.bind(this);
    (<any>window).navigateToPLAMaint = this.navigateToPLAMaint.bind(this);
    (<any>window).navigateToCOSMaint = this.navigateToCOSMaint.bind(this);
  }

  ngOnInit(): void {
    this.callFromNgOnInit = true;
    this.userId = this.userService.currentUser.Id;
    this.yearId = this.yearService.defaultYear.Id;
    this.schoolId = this.yearService.defaultYear.SchoolID;
    this.stateCode = this.loginService.LoginSettings.State;
    this.canEditForm = this.sped360Service.canEditForm;
    this.formsInDDL();
    this.objectIndex = this.ddData.findIndex(x => x.StudentCollectionTemplateVersionId == this.studentFormData.StudentCollectionTemplateVersionId);
    this.selectedForm = this.ddData.find(x => x.StudentCollectionTemplateVersionId == this.studentFormData.StudentCollectionTemplateVersionId);
    if (this.canEditForm == true && this.sped360Service.continueClicked == true && (this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId == 0 || this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId != this.userId)) {
      this.checkOutForm();
    }
    this.iconAllowed = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);

    this.studentCollectionTemplateVersionId = this.studentFormData.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.goalData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.goalData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.goalData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.goalData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.goalData.TemplateName = this.selectedForm.TemplateName;

    this.formWithinDocumentService.pickIdentificationData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.pickIdentificationData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.pickIdentificationData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.pickIdentificationData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.pickIdentificationData.TemplateName = this.selectedForm.TemplateName;

    this.formWithinDocumentService.plaMiantenanceData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.plaMiantenanceData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.plaMiantenanceData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.plaMiantenanceData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.plaMiantenanceData.TemplateName = this.selectedForm.TemplateName;

    this.formWithinDocumentService.courceOfStudyData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.courceOfStudyData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.courceOfStudyData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.courceOfStudyData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.courceOfStudyData.TemplateName = this.selectedForm.TemplateName;

    this.loadHtml();
  }

  ngAfterViewInit(): void {
    this.callFromNgOnInit = false;
  }

  loadHtml() {
    if (this.navigateToForm == true) {
      this.navigateToForm = false;
      if (this.canEditForm == true && this.checkInCheckOut() == true && this.selectedForm.CheckedOutByUserId != this.userId) {
        this.checkInCheckOutDialoge();
      } else {
        if ((this.callFromNgOnInit == false && this.canEditForm == true) || (this.onlySaveClick == true && (this.selectedForm.IsEdit == true || this.canEditForm == true) && (this.selectedForm.CheckedOutByUserId == 0 || this.selectedForm.CheckedOutByUserId == this.userId))) {
          this.checkOutForm();
        }
      }
    }
    else {
      if ((this.callFromNgOnInit == false && this.canEditForm == true) || (this.onlySaveClick == true && (this.selectedForm.IsEdit == true || this.canEditForm == true) && (this.selectedForm.CheckedOutByUserId == 0 || this.selectedForm.CheckedOutByUserId == this.userId))) {
        this.checkOutForm();
      }
    }

    let queryString = '';
    queryString += '?spedCollectionId=' + this.studentFormData.SpEdcollectionId +
      '&studentId=' + this.studentFormData.StudentId +
      '&spedCollectionToStudentId=' + this.studentFormData.StudentCollectionId +
      '&StudentCollectionTemplateVersionId=' + this.selectedForm.StudentCollectionTemplateVersionId +
      '&collectionStatusId=' + this.studentFormData.SpEdCollectionToIEPStatusId +
      '&templateVersionId=' + this.selectedForm.TemplateVersionId +
      '&templateName=' + this.selectedForm.TemplateName +
      '&userId=' + this.userId +
      '&siteId=' + this.schoolId +
      '&yearId=' + this.yearId +
      '&isEdit=' + this.canEditForm; // this.selectedForm.IsEdit;
    this.formSrc = this.sanitizer.bypassSecurityTrustResourceUrl('./SpecialEd.aspx' + queryString);
    setTimeout(() => {
      this.disableNavigationButton = false;
    }, 200);

  }

  closeClick(type: string) {
    if (type == 'close' && this.canEditForm == true) {
      this.warningDialog = this.dialog.open(CheckForErrorsMessageComponent, {
        disableClose: true,
        data: {
          errors: []
        }
      });
      this.warningDialog.componentInstance.dialogBox = this.warningDialog;
      this.warningDialog.afterClosed().subscribe(result => {
        switch (result) {
          case 1: {
            this.saveClick(undefined, false, false, true, true);
            if (this.formWithinDocumentService.callFromAlertDialog == true) {
              setTimeout(() => {
                this.router.navigateByUrl('/sped360/studentDocumentHome');
                this.dialog.closeAll();
              }, 300);
            }
            break;
          }
          case 0: {
            this.callFromCloseButton();
            if (this.formWithinDocumentService.callFromAlertDialog == true) {
              this.router.navigateByUrl('/sped360/studentDocumentHome');
              this.dialog.closeAll();
            }
            break;
          }
          case -1: {
            this.warningDialog.close();
            break;
          }
          default: {
            break;
          }
        }
      });
    } else {
      this.callFromCloseButton();
    }
  }

  callFromCloseButton() {
    this.getStudentCollectionTemplate();
    setTimeout(() => {
      if (this.canEditForm == true && this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit) == true && this.sped360Service.continueClicked == true && (this.selectedForm.StudentXMLDataId != undefined || this.selectedForm.StudnetXMLId != undefined)) {
        this.checkOutForm();
      }
      this.matDialogRef.close();
    }, 300);
  }

  saveClick(callForSaveXmlData: boolean, onlySaveClick: boolean = false, printPreview: boolean = false, errorAuthGuard: boolean = false, buttonClick: boolean = false) {
    let validate: boolean;
    if (onlySaveClick == true && this.navigateToForm == false) {
      this.changeStatus = 'Apply';
    } else if (this.navigateToForm == true) {
      this.changeStatus = 'Navigate';
    } else {
      this.changeStatus = 'Done';
    }
    setTimeout(() => {
      if (printPreview == true || buttonClick == true) {
        this.studentFormData.TemplateVersionId = this.selectedForm.TemplateVersionId;
        this.studentFormData.TemplateName = this.selectedForm.TemplateName;
        this.studentFormData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
      }
      if (!errorAuthGuard && !printPreview && this.iframe.nativeElement.contentWindow.fnRequiredFieldValidation != undefined && callForSaveXmlData != false) {
        validate = this.iframe.nativeElement.contentWindow.fnRequiredFieldValidation();
      }
      if (validate == false || validate == undefined) {
        this.disableNavigationButton = false;
      }
      if (validate == false && this.navigateToForm == true) {
        this.objectIndex = this.previousSelectedForm.PreviousObjectIndex;
        this.studentCollectionTemplateVersionId = this.previousSelectedForm.StudentCollectionTemplateVersionId;
        this.selectedForm = this.previousSelectedForm;
        this.formWithinDocumentService.goalData.StudentId = this.studentFormData.StudentId;
        this.formWithinDocumentService.goalData.StudentCollectionId = this.studentFormData.StudentCollectionId;
        this.formWithinDocumentService.goalData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
        this.formWithinDocumentService.goalData.TemplateVersionId = this.selectedForm.TemplateVersionId;
        this.formWithinDocumentService.goalData.TemplateName = this.selectedForm.TemplateName;

        this.formWithinDocumentService.pickIdentificationData.StudentId = this.studentFormData.StudentId;
        this.formWithinDocumentService.pickIdentificationData.StudentCollectionId = this.studentFormData.StudentCollectionId;
        this.formWithinDocumentService.pickIdentificationData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
        this.formWithinDocumentService.pickIdentificationData.TemplateVersionId = this.selectedForm.TemplateVersionId;
        this.formWithinDocumentService.pickIdentificationData.TemplateName = this.selectedForm.TemplateName;

        this.formWithinDocumentService.plaMiantenanceData.StudentId = this.studentFormData.StudentId;
        this.formWithinDocumentService.plaMiantenanceData.StudentCollectionId = this.studentFormData.StudentCollectionId;
        this.formWithinDocumentService.plaMiantenanceData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
        this.formWithinDocumentService.plaMiantenanceData.TemplateVersionId = this.selectedForm.TemplateVersionId;
        this.formWithinDocumentService.plaMiantenanceData.TemplateName = this.selectedForm.TemplateName;

        this.formWithinDocumentService.courceOfStudyData.StudentId = this.studentFormData.StudentId;
        this.formWithinDocumentService.courceOfStudyData.StudentCollectionId = this.studentFormData.StudentCollectionId;
        this.formWithinDocumentService.courceOfStudyData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
        this.formWithinDocumentService.courceOfStudyData.TemplateVersionId = this.selectedForm.TemplateVersionId;
        this.formWithinDocumentService.courceOfStudyData.TemplateName = this.selectedForm.TemplateName;

      }
      if (errorAuthGuard || printPreview || validate == true || this.formStatus == 'Reviewed by Supervisor' || this.formStatus == 'Completed' || callForSaveXmlData == false) {
        const divHtml = this.iframe.nativeElement.contentWindow.document.getElementById('divHtmlContent');
        const htmlElements = [];
        this.fillArray(divHtml, htmlElements);
        const arrhtmlInputElements = [];
        for (let i = 0; i < htmlElements.length; i++) {
          if (htmlElements[i].id != null && htmlElements[i].value != null) {
            switch (htmlElements[i].type) {
              case 'checkbox':
                let chkvalue = '';
                if (htmlElements[i].getAttribute('formatvalue') != undefined) {
                  if (htmlElements[i].getAttribute('formatvalue') == '10') {
                    if (htmlElements[i].checked == true) {
                      chkvalue = '1';
                    }
                    else {
                      chkvalue = '0';
                    }
                  }
                  if (htmlElements[i].getAttribute('formatvalue') == 'yesno') {
                    if (htmlElements[i].checked == true) {
                      chkvalue = 'yes';
                    }
                    else {
                      chkvalue = 'no';
                    }
                  }
                }
                else {
                  if (htmlElements[i].checked == true) {
                    chkvalue = 'Yes';
                  }
                  else {
                    chkvalue = 'No';
                  }
                }
                arrhtmlInputElements.push({ id: htmlElements[i].id, value: htmlElements[i].value, name: htmlElements[i].id, xmlValue: chkvalue, type: 'checkbox', tablename: '', isdynamic: '' });
                break;
              case 'radio':
                if (htmlElements[i].name != null && htmlElements[i].name.startsWith('rdg')) {
                  let chkvalue1 = '';
                  if (htmlElements[i].checked == true) {
                    chkvalue1 = 'True';
                  }
                  else {
                    chkvalue1 = 'False';
                  }

                  arrhtmlInputElements.push({ id: htmlElements[i].id, value: encodeURIComponent(htmlElements[i].value), name: htmlElements[i].name, xmlValue: chkvalue1, type: 'radio', tablename: '', isdynamic: '' });
                }
                else if (htmlElements[i].id.startsWith('chk')) {
                  let chkvalue2 = '';
                  if (htmlElements[i].getAttribute('formatvalue') != undefined) {
                    if (htmlElements[i].getAttribute('formatvalue') == '10') {
                      if (htmlElements[i].checked == true) {
                        chkvalue2 = '1';
                      }
                      else {
                        chkvalue2 = '0';
                      }
                    }
                    if (htmlElements[i].getAttribute('formatvalue') == 'yesno') {
                      if (htmlElements[i].checked == true) {
                        chkvalue2 = 'yes';
                      }
                      else {
                        chkvalue2 = 'no';
                      }
                    }
                  }
                  else {
                    if (htmlElements[i].checked == true) {
                      chkvalue2 = 'Yes';
                    }
                    else {
                      chkvalue2 = 'No';
                    }
                  }
                  arrhtmlInputElements.push({ id: htmlElements[i].id, value: encodeURIComponent(htmlElements[i].value), name: htmlElements[i].id, xmlValue: chkvalue2, type: 'checkbox', tablename: '', isdynamic: '' });

                }
                break;
              case 'text':
                let value = '';
                if (htmlElements[i].id.toLowerCase().indexOf('phone') > 0 || htmlElements[i].id.toLowerCase().indexOf('fax') > 0 || htmlElements[i].id.toLowerCase().indexOf('tel') > 0 || htmlElements[i].id.toLowerCase().indexOf('telephone') > 0 || htmlElements[i].id.toLowerCase().indexOf('edmpno') > 0) {
                  value = htmlElements[i].value.replace('(', '').replace(')', '').replace('-', '').replace('.', '').replace(/ /g, '');
                }
                else {
                  value = htmlElements[i].value;
                }

                arrhtmlInputElements.push({ id: htmlElements[i].id, value: encodeURIComponent(htmlElements[i].value), name: htmlElements[i].id, xmlValue: encodeURIComponent(value), type: 'text', tablename: '', isdynamic: '' });
                break;
              case 'textarea':
                arrhtmlInputElements.push({ id: htmlElements[i].id, value: encodeURIComponent(htmlElements[i].value), name: htmlElements[i].id, xmlValue: encodeURIComponent(htmlElements[i].value), type: 'textarea', tablename: '', isdynamic: '' });
                break;
              case 'select-one':
                let strxmlvalue = '';
                if (htmlElements[i].options[htmlElements[i].selectedIndex] != undefined) {
                  strxmlvalue = (htmlElements[i].options[htmlElements[i].selectedIndex]).getAttribute('value');
                }
                else {
                  strxmlvalue = '';
                }
                arrhtmlInputElements.push({ id: htmlElements[i].id, value: encodeURIComponent(htmlElements[i].value), name: htmlElements[i].id, xmlValue: encodeURIComponent(strxmlvalue), type: htmlElements[i].getAttribute('type'), tablename: '', isdynamic: '' });

                break;

              // default:
              //    if(this.htmlElements[i].name != null)
              //    {
              //        arrhtmlInputElements.push({ id: this.htmlElements[i].id, value: this.htmlElements[i].value, name: this.htmlElements[i].name, xmlValue: this.htmlElements[i].value, type: ' ', tablename: this.htmlElements[i].tableid, isdynamic: this.htmlElements[i].type });
              //    }
            }
          }
          if (htmlElements[i].id != null && htmlElements[i].id != '') {
            switch (htmlElements[i].tagName) {
              case 'TABLE':
                arrhtmlInputElements.push({ id: htmlElements[i].id, value: '', name: htmlElements[i].id, xmlValue: '', type: '', tablename: htmlElements[i].id, isdynamic: htmlElements[i].getAttribute('type') });
                break;
              case 'TR':
                arrhtmlInputElements.push({ id: htmlElements[i].id, value: '', name: htmlElements[i].id, xmlValue: '', type: '', tablename: htmlElements[i].getAttribute('tableid'), isdynamic: htmlElements[i].getAttribute('type') });
                break;
            }
          }
        }
        const xml = JSON.stringify(arrhtmlInputElements);
        this.spedCardService.saveHTMLDocument(xml, this.studentFormData.StudentId, this.studentFormData.StudentCollectionId, this.studentFormData.TemplateVersionId, this.studentFormData.TemplateName, this.studentFormData.StudentCollectionTemplateVersionId, this.stateCode, this.changeStatus, this.yearId).subscribe(() => {
          this.sharedService.showGoodSnackbar();
          if (callForSaveXmlData == undefined && !onlySaveClick) {
            this.matDialogRef.close('save');
          }
          if (onlySaveClick) {
            this.onlySaveClick = onlySaveClick;
            this.getStudentCollectionTemplate();
            setTimeout(() => {
              this.loadHtml();
            }, 100);
          }
          if (printPreview) {
            this.viewPrintPreview();
          }
        });

      }
    }, 200);

  }

  fillArray(vector1, vector2) {
    if (vector1.children.length > 0) {
      for (let i = 0; i < vector1.children.length; i++) {
        //  this.htmlElements.push(vector1.children[i]);
        this.fillArray(vector1.children[i], vector2);
      }
    }
    vector2.push(vector1);
  }

  compareObjects(o1: number, o2: number): boolean {
    if (o2 == null) {
      o2 = -1;
    }
    return (o1 == o2);
  }

  lastObject() {
    this.disableNavigationButton = true;
    this.previousSelectedForm = this.selectedForm;
    this.previousSelectedForm.PreviousObjectIndex = this.objectIndex;
    this.studentFormData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.studentFormData.TemplateName = this.selectedForm.TemplateName;
    this.studentFormData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.objectIndex = this.ddData.length - 1;
    this.selectedForm = this.ddData[this.ddData.length - 1];
    // this.selectedForm.IsEdit = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
    this.studentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.dropDownChange();
  }

  nextObject() {
    this.disableNavigationButton = true;
    this.previousSelectedForm = this.selectedForm;
    this.previousSelectedForm.PreviousObjectIndex = this.objectIndex;
    this.studentFormData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.studentFormData.TemplateName = this.selectedForm.TemplateName;
    this.studentFormData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.objectIndex = this.ddData.findIndex(x => x.StudentCollectionTemplateVersionId == this.studentCollectionTemplateVersionId) + 1;
    if (this.objectIndex < this.ddData.length) {
      const index = this.ddData.findIndex(x => x.StudentCollectionTemplateVersionId == this.studentCollectionTemplateVersionId);
      this.selectedForm = this.ddData[index + 1];
      // this.selectedForm.IsEdit = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
      this.studentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
      this.dropDownChange();
    }
  }

  previousObject() {
    this.disableNavigationButton = true;
    this.previousSelectedForm = this.selectedForm;
    this.previousSelectedForm.PreviousObjectIndex = this.objectIndex;
    this.studentFormData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.studentFormData.TemplateName = this.selectedForm.TemplateName;
    this.studentFormData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.objectIndex = this.ddData.findIndex(x => x.StudentCollectionTemplateVersionId == this.studentCollectionTemplateVersionId) - 1;
    if (this.objectIndex >= 0) {
      const index = this.ddData.findIndex(x => x.StudentCollectionTemplateVersionId == this.studentCollectionTemplateVersionId);
      this.selectedForm = this.ddData[index - 1];
      // this.selectedForm.IsEdit = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
      this.studentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
      this.dropDownChange();
    }
  }

  firstObject() {
    this.disableNavigationButton = true;
    this.previousSelectedForm = this.selectedForm;
    this.previousSelectedForm.PreviousObjectIndex = this.objectIndex;
    this.studentFormData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.studentFormData.TemplateName = this.selectedForm.TemplateName;
    this.studentFormData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.objectIndex = 0;
    this.selectedForm = this.ddData[0];
    //  this.selectedForm.IsEdit = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
    this.studentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.dropDownChange();
  }

  dropDownChange(selectedFromDD: boolean = false) {
    this.navigateToForm = true;
    if (selectedFromDD == true) {
      this.previousSelectedForm = this.selectedForm;
      this.previousSelectedForm.PreviousObjectIndex = this.objectIndex;
      this.studentFormData.TemplateVersionId = this.selectedForm.TemplateVersionId;
      this.studentFormData.TemplateName = this.selectedForm.TemplateName;
      this.studentFormData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
      this.objectIndex = this.ddData.findIndex(x => x.StudentCollectionTemplateVersionId == this.studentCollectionTemplateVersionId);
      this.selectedForm = this.ddData.find(x => x.StudentCollectionTemplateVersionId == this.studentCollectionTemplateVersionId);
    }
    if (this.canEditForm == true) {
      this.saveClick(true, true);
    } else {
      this.loadHtml();
    }
    this.getStudentCollectionTemplate();
    // this.selectedForm.IsEdit = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
    this.iconAllowed = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
    if (this.canEditForm == true) {
      this.canEditForm = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
    }
    this.formWithinDocumentService.goalData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.goalData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.goalData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.goalData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.goalData.TemplateName = this.selectedForm.TemplateName;

    this.formWithinDocumentService.pickIdentificationData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.pickIdentificationData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.pickIdentificationData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.pickIdentificationData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.pickIdentificationData.TemplateName = this.selectedForm.TemplateName;

    this.formWithinDocumentService.plaMiantenanceData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.plaMiantenanceData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.plaMiantenanceData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.plaMiantenanceData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.plaMiantenanceData.TemplateName = this.selectedForm.TemplateName;

    this.formWithinDocumentService.courceOfStudyData.StudentId = this.studentFormData.StudentId;
    this.formWithinDocumentService.courceOfStudyData.StudentCollectionId = this.studentFormData.StudentCollectionId;
    this.formWithinDocumentService.courceOfStudyData.StudentCollectionTemplateVersionId = this.selectedForm.StudentCollectionTemplateVersionId;
    this.formWithinDocumentService.courceOfStudyData.TemplateVersionId = this.selectedForm.TemplateVersionId;
    this.formWithinDocumentService.courceOfStudyData.TemplateName = this.selectedForm.TemplateName;
  }

  navigateToMaint(fieldName: string, masterType: number) {
    this.navigateToForm = false;
    this.saveClick(false, false, false, false, true);
    const pickGoalBankDialog = this.dialog.open(PickGoalMaintenanceComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      height: '75vh',
      width: '70vw',
    });
    pickGoalBankDialog.componentInstance.dialogTitle = 'IEP Goal Maintenance';
    pickGoalBankDialog.componentInstance.studentXMLDataId = this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId;
    pickGoalBankDialog.componentInstance.masterTypeId = masterType;
    this.formWithinDocumentService.goalData.FieldName = fieldName;
    pickGoalBankDialog.afterClosed().subscribe(result => {
      this.loadHtml();
    });
  }

  navigateToGoalORMaint(fieldName: string, objFieldName: string, masterType: number) {
    this.navigateToForm = false;
    this.saveClick(false, false, false, false, true);
    const pickGoalBankDialog = this.dialog.open(PickGoalMaintenanceComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      height: '75vh',
      width: '70vw',
    });
    pickGoalBankDialog.componentInstance.dialogTitle = 'IEP Goal Maintenance';
    pickGoalBankDialog.componentInstance.masterTypeId = masterType;
    pickGoalBankDialog.componentInstance.studentXMLDataId = this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId;
    this.formWithinDocumentService.goalData.FieldName = fieldName;
    this.formWithinDocumentService.goalData.ObjFieldName = objFieldName;
    pickGoalBankDialog.afterClosed().subscribe(result => {
      this.loadHtml();
    });
  }

  navigateToPLAMaint(category: string, value: number) {
    this.navigateToForm = false;
    this.saveClick(false, false, false, false, true);
    const presentLevelFormDialog = this.dialog.open(PresentLevelMaintenanceComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      height: '100vh',
      maxHeight: '100vh',
      width: '100vw',
      maxWidth: '100vw',
    });
    presentLevelFormDialog.componentInstance.dialogTitle = 'Present Level Maintenance';
    presentLevelFormDialog.componentInstance.studentXMLDataId = this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId;
    this.formWithinDocumentService.plaMiantenanceData.CategoryName = category;
    this.formWithinDocumentService.plaMiantenanceData.RowIndex = value;
    this.formWithinDocumentService.getPlaXMLvalues(this.yearId).subscribe(values => {
      this.getSelectedPlaValues = values;
      this.getsingleValue = this.getSelectedPlaValues[0];
      this.getsingleValue.CategoryNote = this.getsingleValue.CategoryNote.replace(/\r\n/g, '<br/>');;
      presentLevelFormDialog.componentInstance.dataField = this.getsingleValue;
    });
    presentLevelFormDialog.afterClosed().subscribe(result => {
      this.loadHtml();
    });
  }

  navigateToCOSMaint() {
    this.navigateToForm = false;
    this.saveClick(false, false, false, false, true);
    const pickCourseOfStudyDialog = this.dialog.open(PickCourseOfStudyComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      height: '75vh',
      width: '70vw',
    });
    pickCourseOfStudyDialog.componentInstance.dialogTitle = 'Course Of Study';
    pickCourseOfStudyDialog.componentInstance.studentXMLDataId = this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId;
    this.spedManagementService.getIdentificationCode('Course of Study').subscribe(Data => {
      this.getCosData = Data.filter(x => x.Code.trim() != '');
      pickCourseOfStudyDialog.componentInstance.tempCourseOfStudyGrid = this.getCosData;
    });
    pickCourseOfStudyDialog.afterClosed().subscribe(result => {
      this.loadHtml();
    });
  }

  navigateToEvalMaint() {
    this.navigateToForm = false;
    this.saveClick(false, false, false, false, true);
    const pickIdentificationDialog = this.dialog.open(PickIdentificationMaintenanceComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      height: '75vh',
      width: '60vw',
    });
    pickIdentificationDialog.componentInstance.dialogTitle = 'Evaluation Maintenance';
    pickIdentificationDialog.componentInstance.studentXMLDataId = this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId;
    pickIdentificationDialog.afterClosed().subscribe(result => {
      this.loadHtml();
    });
  }

  viewPrintPreview() {
    const viewOverlayDialogPB = this.dialog.open(IndeterminateProgressBarComponent, {
      disableClose: true,
    });
    viewOverlayDialogPB.componentInstance.spEdcollectionId = this.studentFormData.SpEdcollectionId;
    viewOverlayDialogPB.componentInstance.studentId = this.studentFormData.StudentId;
    viewOverlayDialogPB.componentInstance.studentCollectionId = this.studentFormData.StudentCollectionId;
    viewOverlayDialogPB.componentInstance.spEdCollectionToIEPStatusId = this.studentFormData.SpEdCollectionToIEPStatusId;
    viewOverlayDialogPB.componentInstance.templateVersionId = this.selectedForm.TemplateVersionId;
    viewOverlayDialogPB.componentInstance.siteId = 0;
    viewOverlayDialogPB.componentInstance.yearId = this.yearId;
    viewOverlayDialogPB.componentInstance.callFromHomePage = false;
    viewOverlayDialogPB.componentInstance.studentTemplateVersionIds = this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId;
    viewOverlayDialogPB.componentInstance.studentHeader = false;
    viewOverlayDialogPB.componentInstance.printType = 0;

    viewOverlayDialogPB.afterClosed().subscribe(result => {
      if (result == 'print') {
        this.fileAsBlob = null;
        this.fileAsBlob = viewOverlayDialogPB.componentInstance.fileAsBlobString;
        this.openPrintView();
      } else {
        this.onlySaveClick = true;
        this.loadHtml();
      }
    });
  }

  openPrintView() {
    const viewOverlayDialog = this.dialog.open(ViewDocumentComponent, {
      disableClose: true,
      height: '100%',
      width: '100%',
      maxWidth: 'inherit'
    });
    viewOverlayDialog.componentInstance.formSrc = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(this.fileAsBlob));
    viewOverlayDialog.afterClosed().subscribe(() => {
      this.onlySaveClick = true;
      this.loadHtml();
    });
  }

  clickedOnLock() {
    if (!this.canEditForm) {
      if (this.checkInCheckOut() == true && this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit) == true) {
        this.checkInCheckOutDialoge();
      } else {
        this.canEditForm = this.sped360Service.allowToEditDelete(this.selectedForm.IsEdit);
        this.formsInDDL();
        this.loadHtml();
      }
    }
  }

  formsInDDL() {
    if (this.canEditForm == true) {
      this.ddData = this.sped360Service.editHtmlFormdropDownValue(this.ddData); // this.ddData.filter(x => x.IsEdit == true);
    }
  }

  checkInCheckOut(): boolean {
    if (this.loginService.LoginSettings.AllowCheckInOutSpEdForms == true && this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId > 0 && this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId != this.userId) {
      return true;
    } else {
      return false;
    }
  }

  checkInCheckOutDialoge() {
    const checkInCheckOutDialog = this.dialog.open(CheckInCheckOutComponent, {
      disableClose: true,
      height: '35vh',
      width: '40vw',
      maxWidth: 'inherit'
    });
    checkInCheckOutDialog.componentInstance.dialogTitle = 'FORM CHECKED OUT';
    checkInCheckOutDialog.componentInstance.checkedOutBy = this.formWithinDocumentService.spedStudentCollectionTemplate.CheckedOutByUserName;
    checkInCheckOutDialog.componentInstance.templateName = this.selectedForm.TemplateName;
    checkInCheckOutDialog.componentInstance.collectionCode = this.collectionCode;
    checkInCheckOutDialog.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.canEditForm = true;
      } else {
        this.canEditForm = false;
        this.navigateToForm = false;
        //  this.selectedForm.IsEdit = false;
      }
      this.formsInDDL();
      this.loadHtml();
    });
  }

  checkOutForm() {
    this.formWithinDocumentService.checkOutForm(this.selectedForm.StudentXMLDataId != undefined ? this.selectedForm.StudentXMLDataId : this.selectedForm.StudnetXMLId, this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId, false).subscribe(() => {
    });
  }

  getStudentCollectionTemplate() {
    this.formWithinDocumentService.getStudentCollectionTemplate(this.selectedForm.StudentCollectionTemplateVersionId, this.selectedForm.TemplateName).subscribe(result => {
      this.formWithinDocumentService.spedStudentCollectionTemplate = result;
    });
  }

  ngOnDestroy() {
    this.formWithinDocumentService.editHtmlFormDialogOpen = false;
  }

}
